
import { defineComponent, PropType } from 'vue';
import { ITreeFile, ITreeFolder } from '@/codeGeneration/codeGen';
import TreeFile from './TreeFile.vue';
export default defineComponent({
  name: 'TreeFolder',
  components: { TreeFile },
  props: {
    data: {
      type: Object as PropType<ITreeFolder>,
      required: false,
      default: {
        type: 'folder',
        name: 'default',
        children: []
      } as ITreeFolder
    }
  },
  data(): { open: boolean } {
    return { open: false };
  },
  methods: {
    getChildren() {
      return this.$props.data.children;
    },
    setOpen(open: boolean = true) {
      this.open = open;
    },
    onFileClicked(fileSelected: ITreeFile) {
      this.$emit('fileOpened', fileSelected);
    }
  },
  emits: {
    fileOpened(fileSelected: ITreeFile) {
      return fileSelected.type === 'file';
    }
  }
});
